import { Injectable } from '@angular/core';
import {
  Theme,
  light,
  dark,
  defaultTheme,
  green,
  pink,
  purple,
  monochrome,
} from '../interfaces/ThemeInterface';
@Injectable({
  providedIn: 'root',
})
export class ThemeServiceService {
  private active: Theme;
  private availableThemes: Theme[] = [
    light,
    dark,
    defaultTheme,
    green,
    pink,
    purple,
    monochrome,
  ];

  constructor() { }

  setDefaultTheme() {
    this.setActiveTheme(defaultTheme);
  }

  setPurple() {
    this.setActiveTheme(purple);
  }

  setGreen() {
    this.setActiveTheme(green);
  }

  setPink() {
    this.setActiveTheme(pink);
  }

  setDarkTheme(): void {
    this.setActiveTheme(dark);
  }

  setLightTheme(): void {
    this.setActiveTheme(light);
  }

  setMonochrome(): void {
    this.setActiveTheme(monochrome);
  }

  getActiveTheme(): Theme {
    return this.active;
  }

  toggleColorMode(): void {
    // Alterna entre el tema por defecto (con azul) y monocromático (sin azul)
    if (this.active?.name === 'monochrome') {
      this.setActiveTheme(defaultTheme);
    } else {
      this.setMonochrome();
    }
  }

  setActiveTheme(theme: Theme): void {
    this.active = theme;

    Object.keys(this.active.properties).forEach((property) => {
      document.documentElement.style.setProperty(
        property,
        this.active.properties[property]
      );

      // Aplica el estilo a los elementos del footer, si los hay
      const footer = document.querySelector('app-footer') as HTMLElement;
      if (footer) {
        const svgElements = footer.querySelectorAll('div.card-container a svg');

        svgElements.forEach((svg) => {
          const colorFill = theme.name == 'dark' ? '#FFFFFF' : '#000000';
          svg.setAttribute('fill', colorFill);
        });
        const footerLinks = footer.querySelectorAll('.footer__link a') as NodeListOf<HTMLAnchorElement>; ;
        footerLinks.forEach((link) => {
          const colorFill = theme.name == 'dark' ? '#FFFFFF' : '#000000';
          link.style.color = colorFill; // Cambia el color del texto
        });      
      }
      
    });
  }
}
